import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import React from "react";
import ContestBack from "Assets/Images/ContestBack.png";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";

const AccessHints = ({ open, setOpen, type = "redirect" }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <Box
        sx={(theme) => ({
          backgroundImage: `url(${ContestBack})`,
          margin: "16px",
          borderRadius: "8px",
          padding: "16px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        })}
      >
        <IconButton
          sx={{ marginLeft: "auto", display: "flex" }}
          onClick={() => handleClose()}
        >
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            width="16px"
            height="16px"
          />
        </IconButton>
        <Box
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={"16px"}
          textAlign={"center"}
          padding={"60px 0px"}
        >
          <Typography
            display={"flex"}
            justifyContent={"center"}
            variant="title"
            fontWeight={500}
            color="white"
          >
            Sure About Accessing Hint?
          </Typography>
          <Typography color="white">
            Accessing this hint would deduct 100 percent of question's max
            score. Are you sure you want to see this hint?
          </Typography>
          <Box display={"flex"} gap={"16px"}>
            <Button variant="contained">Access Hint</Button>
            <Button
              color="white"
              variant="outlined"
              onClick={() => {
                handleClose();
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default AccessHints;
